import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/:ticket_code",
      name: "index",
      component: HomeView,
    },
  ],
});

export default router;
